import * as React from 'react';
/**
 *
 * Original name: Stacks
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=38434%3A10955
 *
 */
export const StacksPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m32 35.007-20.002-12.81L32 9.515l20 12.681-20 12.811Zm18.412-2.3L32 44.498 13.588 32.706l2.157-3.368L32 39.749l16.255-10.411 2.157 3.368ZM32 53.998l18.412-11.793-2.157-3.368L32 49.249 15.745 38.838l-2.157 3.368L32 54Z", fill: "currentColor" })));
